import { generateSignalDataAccess } from '@/react/utils/generateSignalDataAccess'

import { Menu } from './Menu'

export const [menus0, makeMenusAvailable] = generateSignalDataAccess(Menu, { convertOpts: { autoSave: true } })

//@ts-ignore
window.menus0 = menus0